import * as React from "react";
import { Formik, Form } from "formik";
import { Input, Button, ButtonToolbar } from "components/bootstrap";
const defaultInputProfile = { id: "", title: "", description: "" };
const InputProfileForm = ({
  inputProfile = defaultInputProfile,
  onCancel,
  onSubmit,
  buttonToolbarClassName = void 0,
  buttonText = "Save",
  InputsWrapper = React.Fragment,
  ActionsWrapper = React.Fragment
}) => {
  const { title, description } = inputProfile || defaultInputProfile;
  const EffectiveInputsWrapper = InputsWrapper || React.Fragment;
  const EffectiveActionsWrapper = ActionsWrapper || React.Fragment;
  return /* @__PURE__ */ React.createElement(Formik, { initialValues: { title, description }, onSubmit }, ({ values, handleChange, isSubmitting }) => /* @__PURE__ */ React.createElement(Form, { role: "form" }, /* @__PURE__ */ React.createElement(EffectiveInputsWrapper, null, /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "title",
      name: "title",
      label: "Title",
      type: "text",
      value: values.title,
      onChange: handleChange,
      help: "Meaningful name used to identify this Input Profile.",
      required: true
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "description",
      name: "description",
      label: "Description",
      type: "text",
      value: values.description,
      onChange: handleChange,
      help: "Description for this Input Profile."
    }
  )), /* @__PURE__ */ React.createElement(EffectiveActionsWrapper, null, /* @__PURE__ */ React.createElement(ButtonToolbar, { className: buttonToolbarClassName }, /* @__PURE__ */ React.createElement(Button, { onClick: onCancel }, "Cancel"), /* @__PURE__ */ React.createElement(Button, { type: "submit", bsStyle: "primary", disabled: isSubmitting }, isSubmitting ? "Saving your changes..." : buttonText)))));
};
export default InputProfileForm;
